import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/cases/listpage/businessStartupSupport/Template'

const BusinessStartupSupport: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'事例 実績 新規事業 フィットジャーニー スタートアップ DX 実行力 仮説検証 MVP開発'}
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/cases/business-startup-support/'}
        title="新規事業プロジェクト実行支援 | 事例 | i3DESIGN アイスリーデザイン"
        description="新規事業プロジェクト実行支援のケーススタディを紹介します｜クラウドネイティブ、AI駆動開発、デザインシステムに精通した様々な支援実績がございます。UX/UIデザイン、モダンスタック技術、CI/CD、DevOps環境、AIエージェントをフル活用した開発スタイルで顧客のデジタルシフトを支援します。"
      />
      <Template pageId={1} />
    </>
  )
}

export default BusinessStartupSupport
